<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
        <g>
	<circle class="svg-elevation-background-color" cx="20" cy="20" r="20"/>
            <path class="svg-secondary-color" d="M23.04,22.11c1.51-0.98,2.5-2.68,2.5-4.61c0-3.04-2.46-5.5-5.5-5.5s-5.5,2.46-5.5,5.5
		c0,1.92,0.98,3.6,2.46,4.58c-2.49,1-4.35,3.22-4.87,5.92h1.54c0.68-2.87,3.25-5,6.32-5s5.64,2.13,6.32,5h1.54
		C27.35,25.32,25.5,23.12,23.04,22.11z M16.05,17.5c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4
		C17.84,21.5,16.05,19.71,16.05,17.5z"/>
</g>
</svg>

</template>

<script>
export default {
    name: "userActiveIcon"
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/userActiveIcon.vue